<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 600px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-8 col-md-10">
            <h1 class="display-2 text-white">Hola Usuario</h1>
            <p class="text-white mt-0 mb-5">
              Aquí puede ver los detalles de su dieta
            </p>
            
            <router-link to="/dietas" class="btn btn-info"><span>Volver a Dietas</span></router-link>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Detalles de la dieta</h3>
                </div>
                <div class="col text-right">
                  <router-link :to="{ name: 'Editar Dieta', params: { dietaId: dietaId}}"><base-button type="primary" size="sm"> Editar</base-button></router-link>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <h3>Nombre: {{dieta_name}}</h3>
                    </div>
                  </div>
                </div>
                <div class="pl-lg-4 row align-items-center">
                  <div class="col-lg-3 align-content-left">
                    <label for="">Fecha inicio:</label>
                    <p>{{dieta_inicio}}</p>
                  </div>
                  <div class="col-lg-3 align-content-right">
                    <label for="">Fecha fin:</label>
                    <p>{{dieta_fin}}</p>
                  </div>
                </div>
                <div class="pl-lg-4 row align-items-center">
                    <div class="form-group col-6">
                        <label for="ejercicio_category" class="form-control-label">Tipo: </label>
                        {{ tipo}}
                    </div>
                </div>
                <hr class="my-4" />
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">Detalles</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-12">
                      <span v-html="dieta_description"></span>

                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from '../../firebaseDb';
import { auth } from '../../firebaseDb';

export default {
  name: "show-dieta",
  props: {
        dietaId: {
          type: String,
          defalut: "ASD"
        }
  },
  data() {
    return {
      user: auth.currentUser,
      dates: {
        fecha_inicio: "2020-11-01",
        fecha_fin: "2020-11-30",
      },
      dieta_name: {
        type: String,
        default: 'Nombre dieta'
      },
      dieta_description: {
        type: String,
        default: 'Descripción de la dieta'
      },
      dieta_inicio: {
        type: String,
        default: 'Fecha inicio de la dieta'
      },
      dieta_fin: {
        type: String,
        default: 'Fecha fin de la dieta'
      },
      tipo: {
        type: String,
        default: 'Tipo de dieta'
      }
    };
  },
  created: function() {
    var self = this
    db.collection('users').doc(this.user.uid).collection('dietas').doc(this.dietaId)
    .onSnapshot({ includeMetadataChanges: true }, (doc) => {
      if(doc.exists){
        try{
          let dietaName = doc.data().dieta_name
          self.dieta_name = dietaName

          let dietaDesc = doc.data().dieta_description
          self.dieta_description = dietaDesc

          self.tipo = doc.data().tipo

          let dietaInicio = doc.data().fecha_inicio
           dietaInicio = dietaInicio.toDate().toLocaleDateString('es-ES')
          self.dieta_inicio = dietaInicio

          let dietaFin = doc.data().fecha_fin
           dietaFin = dietaFin.toDate().toLocaleDateString('es-ES')
          self.dieta_fin = dietaFin
        }catch(error){
          console.log(error)
        }
      }
    })
  },
};
</script>
<style>
img{
  max-width: 95%;
}
</style>